import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instanceps1mclk6cv3l as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$defaultuw5a81aphnfp as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instance3ib8lrmu0w6c5 as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().l4e("Buffer doesn't contain required number of bytes (size: " + $this.q2().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.f4e_1 = null;
        this.g4e_1 = null;
        this.h4e_1 = 0n;
      }
      q2() {
        return this.h4e_1;
      }
      m3x() {
        return this;
      }
      n3x() {
        return this.q2() === 0n;
      }
      o3x(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() < byteCount) {
          throw EOFException().l4e("Buffer doesn't contain required number of bytes (size: " + this.q2().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      t3x(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        return this.q2() >= byteCount;
      }
      w3x() {
        var tmp0_elvis_lhs = this.f4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize === 0) {
          this.t4e();
          return this.w3x();
        }
        var v = segment.u4e();
        this.h4e_1 = subtract(this.h4e_1, 1n);
        if (segmentSize === 1) {
          this.t4e();
        }
        return v;
      }
      v4e() {
        var tmp0_elvis_lhs = this.f4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize < 2) {
          this.o3x(2n);
          if (segmentSize === 0) {
            this.t4e();
            return this.v4e();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.w3x() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.w3x() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.w4e();
        this.h4e_1 = subtract(this.h4e_1, 2n);
        if (segmentSize === 2) {
          this.t4e();
        }
        return v;
      }
      x4e() {
        return Unit_instance;
      }
      y4e(out, startIndex, endIndex) {
        checkBounds(this.q2(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.h4e_1 = add(out.h4e_1, remainingByteCount);
        var s = this.f4e_1;
        while (currentOffset >= fromInt(ensureNotNull(s).o4e_1 - s.n4e_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.o4e_1 - s.n4e_1 | 0));
          s = s.r4e_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).z4e();
          copy.n4e_1 = copy.n4e_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.n4e_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.o4e_1;
          tmp.o4e_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.f4e_1 == null) {
            out.f4e_1 = copy;
            out.g4e_1 = copy;
          } else if (false) {
            out.g4e_1 = ensureNotNull(out.g4e_1).a4f(copy).b4f();
            if (ensureNotNull(out.g4e_1).s4e_1 == null) {
              out.f4e_1 = out.g4e_1;
            }
          } else {
            out.g4e_1 = ensureNotNull(out.g4e_1).a4f(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.o4e_1 - copy.n4e_1 | 0));
          currentOffset = 0n;
          s = s.r4e_1;
        }
      }
      c4f() {
        var result = this.q2();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.g4e_1);
        if (tail.o4e_1 < 8192 && tail.q4e_1) {
          result = subtract(result, fromInt(tail.o4e_1 - tail.n4e_1 | 0));
        }
        return result;
      }
      j3w(position) {
        if (position < 0n || position >= this.q2()) {
          throw IndexOutOfBoundsException().i3('position (' + position.toString() + ') is not within the range [0..size(' + this.q2().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.f4e_1).d4f(0);
        }
        $l$block_1: {
          // Inline function 'kotlinx.io.seek' call
          if (this.f4e_1 == null) {
            return ensureNotNull(null).d4f(convertToInt(subtract(position, -1n)));
          }
          if (subtract(this.q2(), position) < position) {
            var s = this.g4e_1;
            var offset = this.q2();
            $l$loop: while (!(s == null) && offset > position) {
              offset = subtract(offset, fromInt(s.o4e_1 - s.n4e_1 | 0));
              if (offset <= position)
                break $l$loop;
              s = s.s4e_1;
            }
            var tmp0 = s;
            var offset_0 = offset;
            return ensureNotNull(tmp0).d4f(convertToInt(subtract(position, offset_0)));
          } else {
            var s_0 = this.f4e_1;
            var offset_1 = 0n;
            $l$loop_0: while (!(s_0 == null)) {
              var tmp0_0 = offset_1;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.o4e_1 - s_0.n4e_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > position)
                break $l$loop_0;
              s_0 = s_0.r4e_1;
              offset_1 = nextOffset;
            }
            var tmp0_1 = s_0;
            var offset_2 = offset_1;
            return ensureNotNull(tmp0_1).d4f(convertToInt(subtract(position, offset_2)));
          }
        }
      }
      a5() {
        return this.x3u(this.q2());
      }
      x3u(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.f4e_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().l4e('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.o4e_1 - head.n4e_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$3 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$3);
          this.h4e_1 = subtract(this.h4e_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.n4e_1 = head.n4e_1 + toSkip | 0;
          if (head.n4e_1 === head.o4e_1) {
            this.t4e();
          }
        }
      }
      e4f(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.f4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.q2();
        var toCopy = Math.min(tmp0, b);
        s.f4f(sink, startIndex, startIndex + toCopy | 0);
        this.h4e_1 = subtract(this.h4e_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.t4e();
        }
        return toCopy;
      }
      g4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.q2() ? this.q2() : byteCount;
        sink.h4f(this, bytesWritten);
        return bytesWritten;
      }
      i4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() < byteCount) {
          sink.h4f(this, this.q2());
          throw EOFException().l4e('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.q2().toString() + ' bytes were written.');
        }
        sink.h4f(this, byteCount);
      }
      j4f(sink) {
        var byteCount = this.q2();
        if (byteCount > 0n) {
          sink.h4f(this, byteCount);
        }
        return byteCount;
      }
      r3z() {
        return buffered(new (PeekSource())(this));
      }
      k4f(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.g4e_1 == null) {
          var result = SegmentPool_instance.a3w();
          this.f4e_1 = result;
          this.g4e_1 = result;
          return result;
        }
        var t = ensureNotNull(this.g4e_1);
        if ((t.o4e_1 + minimumCapacity | 0) > 8192 || !t.q4e_1) {
          var newTail = t.a4f(SegmentPool_instance.a3w());
          this.g4e_1 = newTail;
          return newTail;
        }
        return t;
      }
      n4f(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.k4f(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.o4f();
          var toCopy = Math.min(tmp0, b);
          tail.p4f(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.h4e_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.h4e_1 = add(tmp0_0, fromInt(other));
      }
      h4f(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().n2(toString(message));
        }
        checkOffsetAndCount(source.h4e_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.f4e_1).q2())) {
            var tail = this.g4e_1;
            var tmp;
            if (!(tail == null) && tail.q4e_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.o4e_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.r4f() ? 0 : tail.n4e_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.f4e_1).t4f(tail, convertToInt(remainingByteCount));
              source.h4e_1 = subtract(source.h4e_1, remainingByteCount);
              this.h4e_1 = add(this.h4e_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.f4e_1 = ensureNotNull(source.f4e_1).s4f(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.f4e_1);
          var movedByteCount = fromInt(segmentToMove.q2());
          source.f4e_1 = segmentToMove.u4f();
          if (source.f4e_1 == null) {
            source.g4e_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.f4e_1 == null) {
            this.f4e_1 = segmentToMove;
            this.g4e_1 = segmentToMove;
          } else if (true) {
            this.g4e_1 = ensureNotNull(this.g4e_1).a4f(segmentToMove).b4f();
            if (ensureNotNull(this.g4e_1).s4e_1 == null) {
              this.f4e_1 = this.g4e_1;
            }
          } else {
            this.g4e_1 = ensureNotNull(this.g4e_1).a4f(segmentToMove);
          }
          source.h4e_1 = subtract(source.h4e_1, movedByteCount);
          this.h4e_1 = add(this.h4e_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      v4f(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.g4f(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      w4f(byte) {
        this.k4f(1).x4f(byte);
        this.h4e_1 = add(this.h4e_1, 1n);
      }
      y4f(short) {
        this.k4f(2).z4f(short);
        this.h4e_1 = add(this.h4e_1, 2n);
      }
      l6() {
        return Unit_instance;
      }
      toString() {
        if (this.q2() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$0 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$0);
        var builder = StringBuilder().tb(imul(len, 2) + (this.q2() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.f4e_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.q2()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.a4g(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$4 = b_0 >> 4;
            var tmp_0 = builder.o1(tmp[tmp$ret$4 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$5 = b_0 & 15;
            tmp_0.o1(tmp_1[tmp$ret$5]);
          }
          curr = curr.r4e_1;
        }
        if (this.q2() > fromInt(maxPrintableBytes)) {
          builder.o1(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.q2().toString() + ' hex=' + builder.toString() + ')';
      }
      t4e() {
        var oldHead = ensureNotNull(this.f4e_1);
        var nextHead = oldHead.r4e_1;
        this.f4e_1 = nextHead;
        if (nextHead == null) {
          this.g4e_1 = null;
        } else {
          nextHead.s4e_1 = null;
        }
        oldHead.r4e_1 = null;
        SegmentPool_instance.b4g(oldHead);
      }
      c4g() {
        var oldTail = ensureNotNull(this.g4e_1);
        var newTail = oldTail.s4e_1;
        this.g4e_1 = newTail;
        if (newTail == null) {
          this.f4e_1 = null;
        } else {
          newTail.r4e_1 = null;
        }
        oldTail.s4e_1 = null;
        SegmentPool_instance.b4g(oldTail);
      }
    }
    protoOf($).q4f = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
